module.exports = __webpack_public_path__ + "static/media/XVS-BNB.06f8698a.svg";